import moment from "moment";

export const calendar_ApiV2_transition = (oldForm?: {
    isHolliday: boolean,
    isSecured: boolean,
    info: {
        verificationCenter: {
            _id: string
            name: string
        },
        medCenter: {
            _id: string,
            name: string
        },
        organization: {
            _id: string,
            name: string
        }
    }
    departures: Array<{
        type: "new" | "old",
        startDate: string,
        start_date?: string,
        endDate: string,
        end_date?: string,
        address: string,
        comment: string,
        id?: string
        _id?: string
    }>
}, verCenterId?: string) => {

    const departures = oldForm.departures.map(departure => {
      const start = moment(departure.startDate || departure?.start_date || null,).local(true).format()
      const end = moment(departure.endDate || departure?.end_date || null).local(true).format()

        return ({
            address: departure.address || null,
            comment: departure.comment || null,
            start_date: start,
            end_date: end,
            id: departure?.id || departure?._id || undefined,

        })
    })

    const form = {
        info: {
            verification_id: oldForm?.info?.verificationCenter?._id || verCenterId || null,
            med_id: oldForm?.info?.medCenter?._id || null,
            org_id: oldForm?.info?.organization?._id || null
        },
        is_holliday: oldForm.isHolliday || false,
        is_secured: oldForm.isSecured || false,
        departures
    }

    return form
}